import React, { useEffect, useState, useMemo } from 'react';
import { useAppSelector } from '@redux/hooks';
import StaticLayout from '@components/layout/StaticLayout';
import EnhancedTable from '@components/_old/table/EnhancedTable';
import Loader from '@components/loader/Loader';
import { getHeaders } from './content';
import { mapLookupsToListingData } from './utils';
import { useNavigate } from 'react-router-dom';
import { supervisorApiBaseUrl } from '@utils/env-utils';

const BASE_URL = supervisorApiBaseUrl;

const LookupsPage = () => {
  const user = useAppSelector((state) => state.user);
  const isAdmin = user?.userRoles?.includes('Insurance-Admin');
  const [loading, setLoading] = useState(true);
  const [lookups, setLookups] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [booted, setBooted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin) return;
    setLoading(true);

    fetch(`${BASE_URL}/api/Lookups/types`)
      .then((res) => res.json())
      .then((data) => {
        const filtered = (data || [])
          .filter(
            (type: string) =>
              type === 'Insurance-Brands' || type === 'Insurance-Models'
          )
          .map((type: string) => ({
            name: type === 'Insurance-Brands' ? 'Brand' : 'Model',
            id: type,
          }));
        setLookups(filtered);
      })
      .catch(() => {
        setLookups([]);
      })
      .finally(() => {
        setLoading(false);
        setBooted(true);
      });
  }, [isAdmin]);

  const tableData = useMemo(
    () => mapLookupsToListingData(lookups, pageNumber, pageSize),
    [lookups, pageNumber, pageSize]
  );

  if (!booted) return <Loader />;
  if (!isAdmin) return null;

  return (
    <StaticLayout
      name="Lookups"
      loading={loading}
      leftChildren={null}
      mainChildren={
        <div style={{ marginTop: 20 }}>
          <EnhancedTable
            title={'Lookups'}
            name="lookups"
            orderByAscendingByDefault
            defaultOrderByColumn="name"
            data={tableData}
            headers={getHeaders(navigate)}
            handleRowsPerPageChange={setPageSize}
            handlePageChange={setPageNumber}
            currentPage={pageNumber}
            usePagination={false}
            disableSelection
            hideToolbar
            actions={[]}
            loader={loading}
          />
        </div>
      }
    />
  );
};

export default LookupsPage;
